<template>
  <div>
    <div
      v-if="isLoading"
      class="flex items-center justify-center text-center pb-32 pt-2"
    >
      <spinner size="88" :line-size="12" line-fg-color="#0DA8CD"></spinner>
    </div>
    <div v-else>
      <!-- <div class="flex justify-end w-full my-4">
      <button class="btn-branches">Actualizar sucursales</button>
    </div> -->
      <div v-for="(branch, index) in arrayBranches" :key="index">
        <Branch
          :branch="{ ...branch }"
          :user="{ ...userData }"
          @checkboxSelected="checkboxSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import Branch from "../../components/branches/Branch.vue";
import { getLocalStorage, sortBranches } from "../../utils/utils";

export default {
  name: "Branches",
  components: {
    Spinner,
    Branch,
  },
  data() {
    return {
      userData: {},
      arrayBranches: [],
      isLoading: true,
    };
  },
  async mounted() {
    this.getUserLocalStorage();
    this.getData(true);
  },
  methods: {
    async getData(loading = false) {
      if (loading) {
        try {
          this.isLoading = true;
          const dataBranches = this.getBranchesLocalStorage();
          this.arrayBranches = sortBranches(
            dataBranches,
            this.userData.branch_id
          );
          this.isLoading = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    getBranchesLocalStorage() {
      return getLocalStorage("branches");
    },
    getUserLocalStorage() {
      this.userData = getLocalStorage("user");
    },
    checkboxSelected() {
      this.getData();
      this.getUserLocalStorage();
    },
  },
};
</script>
